import {
  FilesDetailSection,
  FilesHeaderSection,
  reactiveVariables,
  StyledActivityCardBackground
} from 'modules';
import React from 'react';
import {
  Outlet,
  useParams
} from 'react-router-dom';



export type FilesActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FilesActivity = (props: FilesActivityProps) => {
  const params = useParams();
  reactiveVariables.resetDocumentsFilter();

  if (params.documentId) {
    return <Outlet />;
  }

  return (
    <StyledActivityCardBackground.FC>
      <FilesHeaderSection.FC />
      <FilesDetailSection.FC />
    </StyledActivityCardBackground.FC>
  );
};
